
// import createServices from '@/clients/hubble-client-collection'
import useCategories from '@/composable/useCategories';
import useErrorHandler from '~/composable/useErrorHandler';

export default function ({ $hubble }) {
  // load and store categories
  const { catchApiFailureWithNoAction } = useErrorHandler()
  try {
    const { getRootCategories } = useCategories($hubble);
    getRootCategories();
  } catch (error) {
    catchApiFailureWithNoAction(error)
  }
}
